import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import quotesReducer from "./slices/quotesSlice";
import cruisesReducer from "./slices/cruisesSlice";
import dashboardReducer from "./slices/dashboardSlice";
import clientsReducer from "./slices/clientsSlice";
import subscriptionReducer from "./slices/subscriptionSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    quotes: quotesReducer,
    cruises: cruisesReducer,
    dashboard: dashboardReducer,
    clients: clientsReducer,
    subscription: subscriptionReducer,
  },
});

export default store;
